/**
 * Generate a string from a template and a set of variables
 * @param {string} input - The template with one or more dynamic variables to swap in
 * @param {Record<string, string | null>} replacements - Key-value pairs of variables to swap into the template
 * @returns {string} The formatted text string
 */
export function formatTextTemplate(input, replacements) {
  if (!input) return "";
  // Use regex to replace all bracketed variables with their corresponding values
  return input.replace(/\[([^\]]+)\]/g, (match, variable) => {
    // If replacement exists for this variable, use it; otherwise keep original
    return replacements.hasOwnProperty(variable) ? replacements[variable] : match;
  });
}

/** Remove percent signs and spell out percent in descriptive text
 * @param {string} inputText
 * @returns {string}
 **/
export function cleanPercents(inputText) {
  if (!inputText) return "";
  return inputText.replace(/%/g, " percent");
}
